module.exports = __webpack_public_path__ + "img/kefu_avatar.b5c311fb.png";